<script setup lang="ts">
const props = defineProps({
	color: {
		type: String,
		required: false,
		default: "currentColor",
	},
});
</script>

<template>
	<svg width="36" height="29" viewBox="0 0 36 29" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation">
		<path
			d="M16.6667 9.33333L26.6665 19.3331M26.6665 9.33333L16.6667 19.3331M13.667 1H29.667C31.5338 1 32.4668 1 33.1798 1.36331C33.807 1.68289 34.3175 2.19245 34.637 2.81966C35.0004 3.5327 35.0004 4.46612 35.0004 6.33296V22.333C35.0004 24.1998 35.0004 25.1333 34.637 25.8463C34.3175 26.4735 33.807 26.9841 33.1798 27.3037C32.4675 27.6667 31.5358 27.6667 29.6726 27.6667H13.6615C11.7983 27.6667 10.8653 27.6667 10.153 27.3037C9.52579 26.9841 1.31958 15.9607 1 15.3335C1.31958 14.7063 9.52579 1.68289 10.153 1.36331C10.866 1 11.8002 1 13.667 1Z"
			:stroke="props.color"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>
